(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("react-dom"), require("@fortawesome/react-fontawesome"));
	else if(typeof define === 'function' && define.amd)
		define(["moment", "react-dom", "@fortawesome/react-fontawesome"], factory);
	else if(typeof exports === 'object')
		exports["input-2-react"] = factory(require("moment"), require("react-dom"), require("@fortawesome/react-fontawesome"));
	else
		root["input-2-react"] = factory(root["moment"], root["react-dom"], root["@fortawesome/react-fontawesome"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__102__) {
return 